<template>
  <div class="row py-5" id="junte-se-a-nos-no-rendimento">
    <div class="col-12 py-3">
      <div class="container-xxl">
        <div class="row">

          <div class="col-12 col-md-12 mx-auto">
            <h2>Junte-se a nós no <strong>Rendimento</strong></h2>
          </div>

          <div class="col-12 col-md-12 mx-auto">
            <div class="row">
              <div class="col-12 col-md-7">
                <p class="text-color-1 text-justify">Com mais de 30 anos de experiência, o <strong>Rendimento</strong> tem um relacionamento encantador com os clientes e, busca, por meio da tecnologia e agilidade, oferecer soluções sob medida.</p>
                <p class="text-color-1 text-justify">O grupo é formado pelo <strong>Banco Rendimento</strong>, que oferece produtos e serviços focados em câmbio, crédito, investimentos, serviços e soluções de pagamentos. <strong>Cotação Rendimento/câmbio</strong>, sendo uma das principais empresas de câmbio do Brasil, com mais de  29 lojas.</p>
                <p class="text-color-1 text-justify">E <strong>Rendimento/pay</strong>, instituição que oferece soluções de pagamentos e cartões para o gerenciamento de gastos corporativos.</p>

                <div class="d-flex mt-5">
                  <router-link to="/vagas" class="btn btn-color-1 rounded-xl text-color-2 px-4 mr-3">Encontre uma vaga</router-link>
                  <router-link to="/deixe-seu-perfil" class="btn btn-outline-color-1 rounded-xl px-4">Cadastre seu Currículo </router-link>
                </div>
              </div>

              <div class="col-12 col-md-5">
                <div class="circles-imgs">
                  <a href="https://www.rendimento.com.br/" target="_blank">
                    <img src="@/assets/images/circle1.png" />
                    <img src="@/assets/images/circle1.2.png" />
                  </a>
                  <a href="https://www.cotacao.com.br/" target="_blank">
                    <img src="@/assets/images/circle2.png" />
                    <img src="@/assets/images/circle2.2.png" />
                  </a>
                  <a href="https://www.agillitas.com.br/" target="_blank">
                    <img src="@/assets/images/circle3.png" />
                    <img src="@/assets/images/circle3.2.png" />
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'JunteSeANos',

    methods: {
      sendToLogin() {
        this.$store.commit("user/SET_NEXT_ROUTE", { path: "/vagas" });
        this.$store.commit("DEVISE_FORM", "login");
      },
    }
  }
</script>

<style lang="scss" scoped>
  #junte-se-a-nos-no-rendimento{
    padding: 0 40px;
    background: linear-gradient(0deg, rgba(217, 217, 217, 0.2), rgba(217, 217, 217, 0.2)), #FFFFFF;
    @media screen and (max-width: 1100px) {
      padding: 0;
    }
  }

    h2{
      font-size: 36px;
      color: #0A1D6F;
      font-weight: 400;
      strong{
        font-weight: bold;
        color: #00CFD9;
      }
    }

  .circles-imgs{
    position: relative;
    width: 100%;
    height: 100%;
    margin-top: -70px;
    margin-left: 0;

    @media screen and (max-width: 1100px) {
      margin-top: 0;
    }

    @include media-breakpoint-down(sm){
      display: none;
    }

    a{
      position: absolute;

      &:nth-of-type(1){
        width: 15vw;
        top: 0;
        left: 7vw;

        @media screen and (min-width: 1650px) {
          width: 210px;
          top: 0;
          left: 160px;
        }
      }

      &:nth-of-type(2){
        width: 14vw;
        top: 5vw;
        left: 23vw;

        @media screen and (min-width: 1650px) {
          width: 240px;
          top: 60px;
          left: 390px;
        }
      }

      &:nth-of-type(3){
        width: 11vw;
        top: 15vw;
        left: 13vw;

        @media screen and (min-width: 1650px) {
          width: 150px;
          top: 210px;
          left: 260px;
        }
      }

      &:hover{
        img{
          &:nth-of-type(2){
            opacity: 1;
          }
        }
      }

      img{
        position: absolute;
        border-radius: 50%;
        &:nth-of-type(2){
          opacity: 0;
        }
      }
    }
  }

</style>